export default class DialogService {

	init() {
		this.initDialogToggles();
		this.initDialogCloseOnClick();
		this.initCloseButtons();
		this.preventCloseOnBodyClick();
	}

	initDialogToggles() {
		document.querySelectorAll('[data-dialog-target]').forEach((toggle) => {
			toggle.addEventListener('click', (event) => {
				event.preventDefault();
				const target = toggle.dataset.dialogTarget || toggle.parentElement?.dataset.dialogTarget;
				const dialog = document.querySelector(`#${target}`);
				dialog?.showModal() || console.error(`Dialog not found: #${target}`);
			});
		});
	}

	initDialogCloseOnClick() {
		document.querySelectorAll('.js-dialog').forEach((dialog) => {
			dialog.addEventListener('click', () => dialog.close());
		});
	}

	initCloseButtons() {
		document.querySelectorAll('.js-dialog-close').forEach((button) => {
			button.addEventListener('click', () => {
				button.closest('.js-dialog')?.close();
			});
		});
	}

	preventCloseOnBodyClick() {
		document.querySelectorAll('.js-dialog-body').forEach((body) => {
			body.addEventListener('click', (event) => event.stopPropagation());
		});
	}
}
